import React from 'react';
import { Trans } from '@lingui/macro';

export default {
  acquisitionFee: <Trans id="general.cart.priceTransparency.acquisitionFee" />,
  commission: <Trans id="general.cart.priceTransparency.commission" />,
  including: <Trans id="general.cart.priceTransparency.including" />,
  taxes: <Trans id="general.cart.priceTransparency.taxes" />,
  toBePaid: <Trans id="general.cart.priceTransparency.toBePaid" />,
  priceMentionedAbove: (
    <Trans id="general.cart.priceTransparency.priceMentionedAbove" />
  ),
  commercialPremium: (
    <Trans id="general.cart.priceTransparency.commercialPremium" />
  ),
  administrationFee: (
    <Trans id="general.cart.priceTransparency.administrationFee" />
  ),
  receiveMyPolicyDocuments: (
    <Trans id="general.cart.receiveMyPolicyDocuments" />
  ),
  pleaseConsiderEnvironment: (
    <Trans id="general.cart.pleaseConsiderEnvironment" />
  ),
  receiveMyPolicyDocumentsEmail: (
    <Trans id="general.cart.receiveMyPolicyDocumentsEmail" />
  ),
};
